// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 654) return "css/core.chunk.trader.6f2b4d87a93cd6f2f166.css";
	// return url for filenames based on template
	return "css/core." + ({"204":"main~2566fa01","258":"main~acf22cc3","494":"main~182f79bf"}[chunkId] || chunkId) + "." + {"138":"590ca1d9394327d2f0a9","204":"31d6cfe0d16ae931b73c","258":"3d321242e988b6819bb4","494":"bb4e0ddbfe1d424afc69"}[chunkId] + ".main.css";
};